<template>
  <div>
    <div class="fade-slide-left">
      <div class="h-100 d-flex align-items-center justify-content-center">
        <div class="journey--container">
          <h3 class="text-light first-par">
            Halo Orbiters! Welcome to <span class="text-orange">Orbit Pathfinder "Discovery 1.0"</span>. Orbit Pathfinder is our Spaceship to Self and Career Development Journey. We called our astronaut as Orbiters which is <span class="text-orange">You!</span>, who has the courage to knock our spaceship door.
          </h3>
          <br>
          <h3 class="text-light second-par">
            Our journey will have a lot of turbulence along the way, but it is worth the trip. Before we lift off, we would be very happy to know our team personally because you will be on our hall of fame. Buckle Up!
          </h3>
          <button class="btn btn-primary third-par mt-5" type="button" @click="nextSlide">
            Continue <i class="el-icon-right"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="s-signup">
      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="card--container">
            <div class="sign--card">
              <div clas="row card--header">
                <h4 class="my-5 text-darkblue">Let's start by introducing yourself</h4>
              </div>
              <div class="card--content">
                <el-form label-position="top">
                  <label for="name" class="label--card">Name</label>
                  <el-form-item :error="errors.first('name')">
                    <el-input
                      v-model="question.name"
                      name="name"
                      v-validate="'required'"
                      data-vv-as="Name"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <label for="email" class="label--card">Email</label>
                  <el-form-item :error="errors.first('email')">
                    <el-input
                      v-model="question.email"
                      name="email"
                      v-validate="'required|email'"
                      data-vv-as="Email"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <label for="phone" class="label--card">Phone Number</label>
                  <el-form-item :error="errors.first('phone')">
                    <el-input 
                    v-model="question.phone"
                    name="phone"
                    v-validate="'required|numeric'"
                    data-vv-as="Phone"
                    clearable>
                      <template slot="prepend">+62</template>
                    </el-input>
                  </el-form-item>
                  <label for="dateOfBirth" class="label--card">Date Of Birth</label>
                  <el-form-item
                    :error="errors.first('dateOfBirth')"
                  >
                    <el-date-picker
                      v-model="question.dateOfBirth"
                      type="date"
                      name="dateOfBirth"
                      data-vv-as="Date of Birth"
                      v-validate="'required'"
                      placeholder="Pick a date"
                    ></el-date-picker>
                  </el-form-item>
                  <label for="gender" class="label--card">Gender</label>
                  <el-form-item>
                    <el-radio v-model="question.gender" label="Male" name="gender">Male</el-radio>
                    <el-radio v-model="question.gender" label="Female" name="gender">Female</el-radio>
                  </el-form-item>
                  <label for="addresss" class="label--card">Address</label>
                  <el-form-item :error="errors.first('address')">
                    <el-input
                      type="textarea"
                      v-validate="'required'"
                      data-vv-as="Address"
                      :rows="5"
                      name="address"
                      placeholder="Your address here"
                      v-model="question.address"
                    ></el-input>
                  </el-form-item>
                  <label for="grad" class="label--card">Which one are you?</label>
                  <el-form-item>
                    <el-radio v-model="question.radio" label="freshGraduate">Fresh Graduate</el-radio>
                    <el-radio v-model="question.radio" label="universityStudent">University Student</el-radio>
                  </el-form-item>
                  <label for="university" class="label--card">University</label>
                  <el-form-item :error="errors.first('university')">
                    <el-input v-model="question.university"
                    name="university"
                    v-validate="'required'"
                    data-vv-as="University"></el-input>
                  </el-form-item>
                  <label for="major" class="label--card">Major</label>
                  <el-form-item :error="errors.first('major')">
                    <el-input v-model="question.major"
                    name="major"
                    v-validate="'required'"
                    data-vv-as="Major"></el-input>
                  </el-form-item>
                  <div class="card--footer">
                    <button class="btn btn-primary" @click="submitForm" type="button">Continue</button>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TimelineMax, Expo } from "gsap";
const timeline = new TimelineMax();

export default {
  data() {
    return {
      question: {
        name: "",
        email: "",
        phone: '',
        gender: "Male",
        address: "",
        radio: 'freshGraduate',
        university: "",
        major: ""
      }
    };
  },
  methods: {
    submitForm() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          const data = {
            name: this.question.name,
            email: this.question.email,
            phone: `+62${this.question.phone}`,
            gender: this.question.gender,
            dateOfBirth: this.question.dateOfBirth,
            address: this.question.address,
            university: this.question.university,
            radio: this.question.radio,
            major: this.question.major,
          };
          this.$store.dispatch("addToStore", data);
          this.$router.push({ name: "Question" });
        }
      });
    },
    nextSlide() {
      timeline
      .to('.first-par', 1, {
        opacity: 0,
        ease: Expo.easeIn,
      })
      .to('.second-par', 1, {
        opacity: 0,
        ease: Expo.easeIn,
      }, '-=0.8')
      .to('.third-par', 1, {
        opacity: 0,
        ease: Expo.easeIn,
      }, '-=0.8')
      .to('.fade-slide-left', 1, {
        translateX: '-200%',
        width: '0%',
        ease: Expo.easeInOut,
      },'+=0.8')
      .to('.journey--container', 1, {
        translateX: '-200%',
        width: '0%',
        opacity: 0,
        display: 'none',
        ease: Expo.easeInOut,
      }, '-=1.8')
      .to('.sign--card', 0.6, {
        opacity: 1,
        scale: 1,
        ease: Expo.easeInOut,
      }, '-=0.6');
    },
  },
  mounted() {
    timeline.to('.first-par', 1.5, {
      opacity: 1,
      ease: Expo.easeIn,
    }, '+= 1.2')
    .to('.second-par', 1, {
      opacity: 1,
      ease: Expo.easeIn,
    }, '-=0.8')
    .to('.third-par', 1, {
      opacity: 1,
      ease: Expo.easeIn,
    }, '-=0.8');
  },
  beforeRouteLeave(to, from, next) {
    timeline.to('.sign--card', 1.5, {
      scale: '0.97',
      translateY: '10',
      ease: Expo.easeInOut,
    })
    .to('.sign--card', 0.4, {
      opacity: 0,
      onComplete: () => {
        next();
      }
    },'-=0.6');
  },
};
</script>

<style>
</style>